const parseQuery = require('../modules/parseQuery')

const Module = {
    name: 'wpParseForm',
    selectors: {
        submit: '#subscriptionContactSubmit',
        country: '#countriesList',
        period: '#period'
    },
    country: null,
    error: 0,

    init: function () {
        /* Get object of query params  */
        parseQuery.parseQuery( window.location.search )
        if( !!parseQuery.data.hash && Module.checkHash( parseQuery.data.hash ) ) {
            /* If country founded, set another data  */
            Module.getCountry()
            Module.setWpData()
        }
    },
    /* Promise for set country before form submit */
    getCountry: function () {
        if( !parseQuery.data.country ) {
            console.error('Country param not set')
        }
        /* Get countries list by code */
        $.ajax({
            url: $(Module.selectors.country).attr('data-url'),
            method: 'get',
            async: false,
            dataType: 'json',
            data: { page: 1, q: parseQuery.data.country }
        })
        .done( function ( res ) {
            if( !res.results ) {
                console.error('Countries not found')
                Module.error++
            }
            /* Find country by code */
            Module.country = res.results.find( function ( element ) {
                return element.code === parseQuery.data.country
            })
        })
        .fail( function ( e ) {
            console.error(e)
            Module.error++
        })
    },
    /* Set data from params */
    setWpData: function () {
        Module.setWpValues()
        if( !Module.error ) {
            Module.sendFormTrigger()
        }
    },
    /* Submit form */
    sendFormTrigger: function () {
        $(Module.selectors.submit).trigger('click')
    },
    /* Check hash from wp */
    checkHash: function ( hash ) {
        return hash.length === 10 && hash.charAt(0) === 'L' && hash.charAt(9) === '0'
    },
    /* Logic for set values to different inputs */
    setWpValues: function () {
        for ( var key in parseQuery.data ) {
            var value = parseQuery.data[ key ]
            var input = $( "input[name='"+ key +"']" )
            switch (key) {
                case "hash":
                    break
                case "accept_terms":
                    /* accept_terms is required in form  */
                    input.prop("checked", true)
                    break
                case "country":
                    if( Module.country ) {
                        var option = new Option( Module.country.text , Module.country.id, true, true)
                        $(Module.selectors.country).append(option).trigger('change')
                    } else {
                        Module.error++
                    }

                    break
                case "period_id":
                    $(Module.selectors.period).val(value).trigger('change');
                    break
                case "phone":
                    value = value.replace(/\D/g, '')
                    input.val(value)
                    break
                default:
                    input.val(value)
            }
        }
    }
}

module.exports = Module
